const products = [
  {
    id: "vpn",
    name: "VPN",
    tagline: "Secure. Private. Fast.",
    description:
      "Our VPN app delivers military-grade encryption and blazing-fast connection speeds, keeping your online activity private and your data safe. Whether you're on public Wi-Fi or browsing from home, stay protected at all times.",
    features: [
      "256-bit AES encryption",
      "Zero-log policy",
      "Global server network",
      "One-tap connection",
    ],
    icon: "ri-shield-keyhole-line",
    gradient: "from-slate-800 to-slate-900",
    accentColor: "text-emerald-400",
    accentBg: "bg-emerald-400/15",
    accentBorder: "border-emerald-400/30",
    image:
      "https://public.readdy.ai/ai/img_res/c77bbf641e425d695db30722d02eb61f.jpg",
  },
  {
    id: "cleaner",
    name: "Cleaner",
    tagline: "Clean. Optimize. Breathe.",
    description:
      "Cleaner intelligently scans your iOS device to remove junk files, duplicate photos, and unnecessary cache data. Reclaim storage space and keep your iPhone running at peak performance with just a few taps.",
    features: [
      "Smart junk detection",
      "Duplicate photo finder",
      "Cache & temp file removal",
      "Storage analytics",
    ],
    icon: "ri-sparkling-line",
    gradient: "from-zinc-800 to-zinc-900",
    accentColor: "text-teal-400",
    accentBg: "bg-teal-400/15",
    accentBorder: "border-teal-400/30",
    image:
      "https://readdy.ai/api/search-image?query=sleek%20modern%20iOS%20cleaner%20app%20interface%20mockup%20on%20iPhone%2C%20dark%20theme%20with%20teal%20sparkle%20icon%2C%20clean%20minimal%20UI%20showing%20storage%20usage%20chart%20and%20cleanup%20progress%2C%20professional%20product%20photography%20on%20pure%20white%20background%2C%20ultra%20sharp%2C%20high%20quality%20render&width=480&height=600&seq=montana-cleaner-product&orientation=portrait",
  },
];

export default function Products() {
  return (
    <section id="products" className="bg-[#F7F8FA] py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="text-center mb-20">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-gray-400 mb-4">
            What We Build
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Products
          </h2>
          <div className="w-16 h-0.5 bg-emerald-400 mx-auto" />
          <p className="mt-6 text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            Thoughtfully designed iOS applications that protect your privacy and
            keep your device running at its best.
          </p>
        </div>

        {/* Product cards */}
        <div className="space-y-10">
          {products.map((product, idx) => (
            <div
              key={product.id}
              className={`bg-gradient-to-br ${product.gradient} rounded-3xl overflow-hidden`}
            >
              <div
                className={`flex flex-col ${
                  idx % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                } items-center gap-0`}
              >
                {/* Text side */}
                <div className="flex-1 p-10 md:p-14">
                  <div
                    className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl ${product.accentBg} border ${product.accentBorder} mb-6`}
                  >
                    <i className={`${product.icon} ${product.accentColor} text-2xl`} />
                  </div>
                  <h3 className="text-4xl font-bold text-white mb-2">
                    {product.name}
                  </h3>
                  <p className={`text-sm font-semibold tracking-widest uppercase ${product.accentColor} mb-5`}>
                    {product.tagline}
                  </p>
                  <p className="text-white/65 text-base leading-relaxed max-w-md mb-8">
                    {product.description}
                  </p>
                  <ul className="space-y-3">
                    {product.features.map((feat) => (
                      <li key={feat} className="flex items-center gap-3">
                        <div
                          className={`w-5 h-5 flex items-center justify-center rounded-full ${product.accentBg}`}
                        >
                          <i className={`ri-check-line ${product.accentColor} text-xs`} />
                        </div>
                        <span className="text-white/70 text-sm">{feat}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Image side */}
                <div className="flex-shrink-0 w-full lg:w-[340px] flex items-end justify-center px-8 pb-0 pt-8 lg:pt-0">
                  <img
                    src={product.image}
                    alt={`${product.name} app screenshot`}
                    className="w-48 md:w-56 lg:w-64 h-auto object-top rounded-2xl"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
